import CKEditorController from './ckeditor_controller'

application.register("ckeditor", CKEditorController);
